export const FIND_TABLE_CONFIGS_REQUEST = 'FIND_TABLE_CONFIGS_REQUEST';

export const findTableConfigsRequest = (id) => ({
  type: FIND_TABLE_CONFIGS_REQUEST,
  payload: {
    id
  }
});
